// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_iy-0";
export var actionModalContentContainer = "_iy-1";
export var createTagButton = "_iy-2";
export var footerContainer = "_iy-7";
export var fullWidthDivider = "_iy-3";
export var hasCreateTagButton = "_iy-4";
export var noCreateTagButton = "_iy-5";
export var tagsContainer = "_iy-6";
export var tagsModalContentContainer = "_iy-8";